
































import {Component, Prop, Vue} from "vue-property-decorator";
import JsonViewer from 'vue-json-viewer'
import format from "@/valchrom/views/mathservice/dataset/overview/NumberFormat";

@Component({
    components: {
        JsonViewer,
        VisualComponent: () => import("@/valchrom/views/mathservice/dataset/overview/VisualComponent.vue")
    }
})
export default class TableComponent extends Vue {
    @Prop() model: any;

    format(val: any, data_type: string){
        if(val == -1.618033989 || val == null){
            return "";
        }
        return format(val, data_type);
    }

    columnHasData(column : string){
        for(let row of this.model.rows){
            let value = row[column];
            if(value != -1.618033989 || value == null){
                return true;
            }
        }
        return false;
    }
}
